var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dw-layout"}},[_c('el-container',{staticStyle:{"padding":"0px"}},[_c('el-container',{staticStyle:{"z-index":"1"}},[_c('el-container',[_c('el-main',{staticStyle:{"padding":"0px"}},[_c('router-view')],1),_vm._v(" "),_c('el-footer',[_c('dw-footer')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd408b7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/NoTopLayout.vue
// module id = null
// module chunks = 